'use client';

import { createContext, PropsWithChildren, useContext } from 'react';

type StoreCardContextData = {
  store: AdaptedStore | AdaptedStore<true>;
};

const StoreCardContext = createContext({} as StoreCardContextData);

export type StoreCardContextProps = PropsWithChildren<{
  store: AdaptedStore | AdaptedStore<true>;
}>;

export function StoreCardContextProvider({
  store,
  children,
}: StoreCardContextProps) {
  return (
    <StoreCardContext.Provider value={{ store }}>
      {children}
    </StoreCardContext.Provider>
  );
}

export function useStoreCard() {
  const context = useContext(StoreCardContext);

  if (!context) {
    throw new Error('useStoreCard must be used within a StoreCardProvider');
  }

  return context;
}
